


import SocialThemeItemComponent from "./components/SocialThemeItemComponent.vue";
import BreakpointService from "@/shared/services/breakpoint-service";
import {Breakpoint} from "@/shared/models/breakpoint-type";
import {defineComponent, onMounted} from "@vue/composition-api";
import {useGetters, useMutations, useState} from "vuex-composition-helpers";

export default defineComponent({
  name: "SocialThemeWidget",
  components: {
    SocialThemeItemComponent,
  },
  props: {
    moreButtonLabel: {String, required: true},
    moreButtonUrl: {String, required: true},
    themes: {Object, required: true},
  },
  setup(props) {
    const {themeItems, maxAmount, currentBreakpoint} = useState([
      "themeItems",
      "maxAmount",
      "currentBreakpoint",
    ]);

    const {setCurrentBreakpoint, setThemeItems, setMaxAmount} = useMutations([
      "setCurrentBreakpoint",
      "setThemeItems",
      "setMaxAmount",
    ]);

    const {items} = useGetters(['items']);

    function setMaxAmountOfPosts(maxAmount: number) {
      setMaxAmount(maxAmount);
    }

    function setMaxAmountOfItems() {
      switch (currentBreakpoint.value) {
        case Breakpoint.TabletPortrait:
          setMaxAmount(6);
          break;
        case Breakpoint.Mobile:
          setMaxAmount(4);
          break;
        default:
          setMaxAmount(8);
          break;
      }
    }

    onMounted(() => {
      setThemeItems(props.themes);
      setCurrentBreakpoint(BreakpointService.currentBreakpoint);
      setMaxAmountOfItems();
    });

    return {
      themeItems,
      maxAmount,
      currentBreakpoint,
      items,
      setMaxAmountOfPosts,
    };
  },
});
